import React from "react";

/**
 * Horizontal tab strip for the Media Library modal.
 * `tabs` is an array of { key, label, icon }.
 */
const MediaLibraryTabs = ({ tabs = [], activeKey, onChange }) => (
  <div className="xc-ml-tabs" role="tablist">
    {tabs.map((tab) => (
      <button
        key={tab.key}
        type="button"
        role="tab"
        aria-selected={activeKey === tab.key}
        className={`xc-ml-tab ${activeKey === tab.key ? "is-active" : ""}`}
        onClick={() => onChange?.(tab.key)}
      >
        {tab.icon ? <i className={tab.icon} aria-hidden="true" /> : null}
        {tab.label}
      </button>
    ))}
  </div>
);

export default MediaLibraryTabs;
